import React from "react";
import "./MeetingPageHeader.css";
import { formatDate2 } from "../../../../utils/dateFormats";
import { ISession } from "../../../../types/dashboard";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../../appContext";
import tripleArrowLeft from "../../../../assets/triple-arrow-left.svg";

interface IMeetingPageHeaderProps {
    clientName: string;
    session: ISession;
    clientAvatar?: string;
    onViewProfile?: () => void;
}

export const MeetingPageHeader = ({clientName, session, clientAvatar, onViewProfile}: IMeetingPageHeaderProps) => {
    const navigate = useNavigate();
    const { translate, currentLanguage } = useAppContext();

    const handleBack = () => {
        navigate(-1);
    };

    const viewProfile = ()=>{
        if (onViewProfile) {
            onViewProfile();
        }
    }

    return (
        <div className="meetingPageHeader">
            <div className="meetingPageHeader_left">
                <div className="meetingPageHeader_title">
                    <div className="meetingPageHeader_title_icon"></div>
                    {translate('session_with')} {clientName}
                </div>
                <div className="meetingPageHeader_back">
                    <button className="meetingPageHeader_back_button" onClick={handleBack}>
                        <img src={tripleArrowLeft} alt={translate('alt_back')} className="meetingPageHeader_back_arrow" />
                        <span className="meetingPageHeader_back_text">{translate('meeting_back')}</span>
                    </button>
                </div>
            </div>
            <div className="meetingPageHeader_right">
                <div className="meetingPageHeader_client">
                    <div className="meetingPageHeader_client_avatar" style={{backgroundImage: `url(${clientAvatar || '/src/assets/ava1.png'})`}}></div>
                    <div className="meetingPageHeader_client_info">
                        <div className="meetingPageHeader_client_name">{clientName}</div>
                        <button className="meetingPageHeader_view_profile_button" onClick={viewProfile}>
                            {translate('view_profile')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}